import { HandbookV2 } from 'types'

export enum HandbookActions {
  SET_HANDBOOK = 'SET_HANDBOOK',
  UPDATE_HANDBOOK = 'UPDATE_HANDBOOK',
}

export function setHandbook(handbook: HandbookV2 | null) {
  return { type: HandbookActions.SET_HANDBOOK, payload: handbook }
}

export function updateHandbook(payload: Partial<HandbookV2>) {
  return { type: HandbookActions.UPDATE_HANDBOOK, payload }
}
